import { Icon20SmileAddOutline, Icon24Add } from '@vkontakte/icons';
import { Button, Spacing, Text, Title } from '@vkontakte/vkui';
import classNames from 'clsx';
import mascotImage from 'img/family-content/empty-block-mascot.png';
import mascotPawsImage from 'img/family-content/empty-block-paws.png';
import { xray } from 'lib/xray';
import React, { type ReactElement } from 'react';
import { useDispatch } from 'react-redux';
import { historyPush } from 'reactApp/modules/router/router.module';
import styles from 'reactApp/ui/FamilyContentEmpty/FamilyContentEmpty.css';

export const FamilySubscription = (): ReactElement => {
    const dispatch = useDispatch();
    const onClick = () => {
        xray.send('empty_family-add_member', { p: 'cloud' });
        dispatch(historyPush({ id: `/family` }));
    };
    return (
        <div className={styles.card} onClick={onClick} data-qa-id="family-subscription">
            <div className={styles.icon}>
                <Icon20SmileAddOutline data-qa-id="family-subscription-icon" />
            </div>
            <Spacing size={24} style={{ pointerEvents: 'none' }} />
            <Title level="2" data-qa-id="family-subscription-title">
                Пригласите ещё <br /> 3 близких
            </Title>
            <Spacing size={8} style={{ pointerEvents: 'none' }} />
            <Text data-qa-id="family-subscription-content">Семейной подпиской можно пользоваться вчетвером</Text>
            <Spacing size={25} style={{ pointerEvents: 'none' }} />
            <Button
                mode="outline"
                appearance="accent-invariable"
                size="l"
                className={styles.outlineButton}
                after={<Icon24Add />}
                data-qa-id="family-subscription-button"
            >
                Добавить близких
            </Button>
            <img
                src={mascotImage}
                alt="Близкие в подписке"
                className={classNames(styles.image, styles.mascot)}
                data-qa-id="family-subscription-mascot"
            />
            <img
                src={mascotPawsImage}
                alt="Близкие в подписке"
                className={classNames(styles.image, styles.mascotPaws)}
                data-qa-id="family-subscription-mascot-paws"
            />
        </div>
    );
};
